var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSemiCircleGroup = function SvgSemiCircleGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 117,
    viewBox: "0 0 415 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 116.53C0 63.285 42.7 20 95.223 20c52.523 0 95.222 43.285 95.222 96.53H0ZM268 69c0-13.236 10.764-24 24-24s24 10.764 24 24h-48ZM414.043 0c0 24.515-19.649 44.626-44.021 44.626C345.649 44.626 326 24.707 326 0h88.043Z",
    fill: "#1279B4",
    fillOpacity: 0.05
  })));
};

export default SvgSemiCircleGroup;